// import axios from 'axios'
// import { jwtDecode } from 'jwt-decode'
// import { BASE_URL } from '../utils/constants'
// import { message } from 'antd'
// import { apis } from './APIS'

// const http = axios.create({
//   baseURL: BASE_URL,
//   // timeout: 15000,
// })

// const isTokenValid = (token) => {
//   if (!token) return false
//   try {
//     const decodedToken = jwtDecode(token)
//     const currentTime = Math.floor(Date.now() / 1000)
//     // Check if token has expired
//     return decodedToken.exp > currentTime
//   } catch (e) {
//     message.error(e.message)
//     return false
//   }
// }

// // Request interceptor
// http.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token')
//     if (token) {
//       if (isTokenValid(token)) {
//         config.headers['Authorization'] = `Bearer ${token}`
//       } else {
//         localStorage.removeItem('token');
//         localStorage.removeItem('refresh');
//         handleLogout()
//       }
//     }
//     return config
//   },
//   (error) => {
//      message.error('Something went wrong')
//     return Promise.reject(error)
//   },
// )

// // Response interceptor
// http.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.code === 'ECONNABORTED') {
//        message.error('Request timeout error:', error.message)
//     } else {
//        message.error(error)
//     }
//     if (error.response && error.response.status === 401) {
//       await handleLogout()
//     }
//      message.error('Something went wrong')
//     return Promise.reject(error)
//   },
// )

// const handleLogout = async () => {
//   try {
//     const refreshToken = localStorage.getItem('refresh')
//     if (refreshToken) {
//       await http.post(apis.logout, { refresh: refreshToken })
//     }
//     localStorage.removeItem('token')
//     localStorage.removeItem('refresh')
//     window.location.href = '/auth/login'
//   } catch (error) {
//     localStorage.removeItem('token')
//     window.location.href = '/auth/login'
//   }
// }

// export default http
import axios from 'axios'
import { jwtDecode } from 'jwt-decode'  // Corrected import
import { BASE_URL } from '../utils/constants'
import { message } from 'antd'
import { apis } from './APIS'

// Create axios instance
const http = axios.create({
  baseURL: BASE_URL,
  // timeout: 15000, 
})

// Token validation function
const isTokenValid = (token) => {
  if (!token) return false
  try {
    const decodedToken = jwtDecode(token)
    const currentTime = Math.floor(Date.now() / 1000)
    // Check if token has expired
    return decodedToken.exp > currentTime
  } catch (e) {
    message.error(e.message)
    return false
  }
}

// Request interceptor
http.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      if (isTokenValid(token)) {
        config.headers['Authorization'] = `Bearer ${token}`
      } else {
        localStorage.removeItem('token')
        localStorage.removeItem('refresh')
        await handleLogout()
      }
    }
    return config
  },
  (error) => {
    message.error('Something went wrong')
    return Promise.reject(error)
  },
)

// Response interceptor
http.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.code === 'ECONNABORTED') {
      message.error(`Request timeout error: ${error.message}`)
    } else if (error.response && error.response.status === 401) {
      await handleLogout()
    } else {
      message.error(error.message || 'Something went wrong') // Improved error handling
    }
    return Promise.reject(error)
  },
)

// Logout handler function
const handleLogout = async () => {
  try {
    const refreshToken = localStorage.getItem('refresh')
    if (refreshToken) {
      await http.post(apis.logout, { refresh: refreshToken })
    }
  } catch (error) {
    message.error('Logout failed')
  } finally {
    localStorage.removeItem('token')
    localStorage.removeItem('refresh')
    window.location.href = '/auth/login'
  }
}

export default http
